export default __webpack_public_path__ + "static/Trail-bb21d4b754451f65cf03620223b7d28e.webp";